import React, {
  lazy,
  Suspense,
  memo,
} from 'react'

import {
  useSelector,
} from 'react-redux'

import {
  useLocation,
} from 'react-router-dom'

import {
  ConfigProvider,
} from 'antd'

import Loading
  from 'components/shared-components/Loading'

import {
  lightTheme,
  darkTheme,
} from 'configs/ThemeConfig'

import {
  resources,
} from 'lang'

import useBodyClass
  from 'utils/hooks/useBodyClass'

import Routes
  from 'routes'


const AppLayout =
  lazy(
    () =>
      import(
        './AppLayout'
      ),
  )


const AuthLayout =
  lazy(
    () =>
      import(
        './AuthLayout'
      ),
  )


const Layouts = () => {
  const token =
    useSelector(
      state =>
        state.auth.token,
    )


  const blankLayout =
    useSelector(
      state =>
        state.theme.blankLayout,
    )


  const location =
    useLocation()


  // ======================================================
  // ROTAS PÚBLICAS QUE SEMPRE DEVEM ABRIR EM BLANK/AUTH
  //
  // Mesmo que o usuário esteja logado.
  // ======================================================

  const isPublicExperienceRoute =
    (
      location.pathname
        .startsWith(
          '/play/',
        )
      ||
      location.pathname
        .startsWith(
          '/join/',
        )
      ||
      location.pathname
        .startsWith(
          '/lobby/',
        )
      ||
      location.pathname
        .startsWith(
          '/offline-prepare/',
        )
      ||
      location.pathname
        .startsWith(
          '/p/',
        )
      ||
      location.pathname
        .startsWith(
          '/r/',
        )
    )


  // ======================================================
  // ESCOLHA DO LAYOUT
  // ======================================================

  const Layout =
    token &&
    !blankLayout &&
    !isPublicExperienceRoute
      ? AppLayout
      : AuthLayout


  // ======================================================
  // TEMA
  // ======================================================

  const locale =
    useSelector(
      state =>
        state.theme.locale,
    )


  const direction =
    useSelector(
      state =>
        state.theme.direction,
    )


  const currentTheme =
    useSelector(
      state =>
        state.theme.currentTheme,
    )


  const currentAppLocale =
    resources[
      locale
    ]


  useBodyClass(
    `dir-${direction}`,
  )


  const themeConfig =
    currentTheme ===
    'light'
      ? {
          ...lightTheme,
        }
      : {
          ...darkTheme,
        }


  // ======================================================
  // RENDER
  // ======================================================

  return (
    <ConfigProvider
      theme={
        themeConfig
      }
      direction={
        direction
      }
      locale={
        currentAppLocale
          .antd
      }
    >
      <Suspense
        fallback={
          <Loading
            cover="content"
          />
        }
      >
        <Layout>
          <Routes />
        </Layout>
      </Suspense>
    </ConfigProvider>
  )
}


export default memo(
  Layouts,
)